import React from "react";

function ButtonV2({ 
  btnName,
  btnOnClick,
  className,
  btnNameClassName,
}) {
  return (
    <div className="equipbid-signup-btn">
      <button className={className && className} onClick={btnOnClick}>
        <span className={btnNameClassName && btnNameClassName}>{btnName}</span>
      </button>
    </div>
  );
}

export default ButtonV2;
